import {
    sendCreateFileArgs,
    sendDeleteFileArgs,
    sendEditFileArgs, sendGrepCodebaseCommandArgs,
    sendMoveFileArgs, sendOpenFileCommandArgs,
    sendRunTerminalCommandArgs, sendSearchCodebaseCommandArgs, sendViewDirectoryCommandArgs, sendReviewChangesCommandArgs
} from "./argFormatter.ts";

export const runToolCall = (llmRequestRefs: any, finishedToolCall: any, environmentObjRef: any, dynamicStateObjRef: any, settingsObjRef: any) => {
    if (finishedToolCall.name === "editFile") {
        sendEditFileArgs(llmRequestRefs, finishedToolCall, environmentObjRef, settingsObjRef);
    }
    else if (finishedToolCall.name === "createFile") {
        sendCreateFileArgs(finishedToolCall, environmentObjRef, settingsObjRef);
    }
    else if (finishedToolCall.name === "deleteFile") {
        sendDeleteFileArgs(finishedToolCall, environmentObjRef);
    }
    else if (finishedToolCall.name === "moveFile") {
        sendMoveFileArgs(finishedToolCall, environmentObjRef, settingsObjRef);
    }
    else if (finishedToolCall.name === "runTerminalCommand") {
        sendRunTerminalCommandArgs(finishedToolCall, environmentObjRef);
    }
    else if (finishedToolCall.name === "searchCodebase") {
        sendSearchCodebaseCommandArgs(finishedToolCall, environmentObjRef, llmRequestRefs.current.additionalContext.serverResponseResults);
    }
    else if (finishedToolCall.name === "grepCodebase") {
        sendGrepCodebaseCommandArgs(finishedToolCall, environmentObjRef);
    }
    else if (finishedToolCall.name === "openFile") {
        sendOpenFileCommandArgs(finishedToolCall, environmentObjRef);
    }
    else if (finishedToolCall.name === "viewDirectory") {
        sendViewDirectoryCommandArgs(finishedToolCall, environmentObjRef);
    }
    else if (finishedToolCall.name === "reviewChanges") {
        sendReviewChangesCommandArgs(finishedToolCall, environmentObjRef, dynamicStateObjRef);
    }
}

export const runOrQueueToolCall = async (llmRequestRefs: any, type: string, environmentObjRef: any, finishedToolCall: any = null, dynamicStateObjRef: any = null, settingsObjRef: any = null) => {
    if (type === "newCall") {
        llmRequestRefs.current.toolCallQueue.push(finishedToolCall);

        if (llmRequestRefs.current.toolCallQueue.length === 1) {
            runToolCall(llmRequestRefs, finishedToolCall, environmentObjRef, dynamicStateObjRef, settingsObjRef);
        }
    } else {
        if (llmRequestRefs.current.toolCallQueue.length !== 0) {
            finishedToolCall = llmRequestRefs.current.toolCallQueue.shift();

            runToolCall(llmRequestRefs, finishedToolCall, environmentObjRef, dynamicStateObjRef, settingsObjRef);
        }
    }
}